export const actionTypes = {
  CHANGE_SEARCH_FIELD: "CHANGE_SEARCH_FIELD",
  REQUEST_ROBOTS_FAILED: "REQUEST_ROBOTS_FAILED",
  REQUEST_ROBOTS_SUCCESS: "REQUEST_ROBOTS_SUCCESS",
  REQUEST_ROBOTS_PENDING: "REQUEST_ROBOTS_PENDING",
};
